import { IncomingMessage } from 'http';
import type { Metadata } from 'next';

/* there's a bug that an upgrade of NextJS might fix
https://github.com/vercel/next.js/issues/52266 */
const workAroundNextJsDoubleSetBug = ( value: string | string[] | undefined ) =>
	typeof value === 'string'
		? value.indexOf( ',' )
			? value.split( ',' )[ 0 ]
			: value
		: typeof value === 'undefined'
			? value
			: value[ 0 ];

/* Helper to derive the current origin from a server request when available,
or fall back to the browser origin on the client. */
export const getHostnameAndProtocolFromRequest = ( request?: IncomingMessage ) =>
	request
		? `${ workAroundNextJsDoubleSetBug(
			request.headers[ 'x-forwarded-proto' ]
		  ) }://${ workAroundNextJsDoubleSetBug( request.headers[ 'x-forwarded-host' ] ) }`
		: typeof window !== 'undefined'
			? window.location.origin
			: undefined;

export const capitalize = ( term: string | string[] ) =>
	[ ...( typeof term === 'string' ? [ term ] : term ) ]
		.map( ( term ) => `${ term.charAt( 0 ).toUpperCase() }${ term.slice( 1 ) }` )
		.join( ' ' );

export type PageHeadBaseProps = {
	hostnameAndProtocol?: string;
};

export type PageHeadProps = PageHeadBaseProps & {
	title: string;
	path: string;
	ogDescription?: string;
	ogImageUrl?: string;
};

export const getMetadata = ( {
	hostnameAndProtocol,
	title,
	path,
	ogDescription,
	ogImageUrl,
}: PageHeadProps ) => {
	const fullTitle = `${ title } - Rock Paper Coin`;
	const canonicalUrl = `${ hostnameAndProtocol }${ path }`;
	const metadata: Metadata = {
		title: fullTitle,
		alternates: {
			canonical: canonicalUrl,
		},
		openGraph: {
			title: fullTitle,
			url: canonicalUrl,
			type: 'website',
			siteName: 'Rock Paper Coin',
			...( ogDescription ? { description: ogDescription } : {} ),
			...( ogImageUrl ? { image: ogImageUrl } : {} ),
		},
	};
	return metadata;
};

//utility to strip the signed url params off of the url returned from api
export const stripSignedParamsFromUrl = ( name: string | null | undefined ) => {
	if ( typeof name === 'string' && name.indexOf( '?' ) !== -1 ) {
		return name.slice( 0, name.lastIndexOf( '?' ) );
	}
	return name;
};

export const getFileExtension = ( url: string | null | undefined ) => {
	if ( typeof url === 'string' ) {
		url = stripSignedParamsFromUrl( url );
		if ( url?.lastIndexOf( '.' ) !== -1 ) {
			return url?.slice( url.lastIndexOf( '.' ), url.length );
		}
	}
};

export const camelCaseToWordsWithWhiteSpace = ( text: string ) =>
	text.replace( /([a-z])([A-Z])/g, '$1 $2' );
